/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SpendRuleUsage,
  SpendRuleUsage$inboundSchema,
} from "./spendruleusage.js";

export type SpendRulesOverviewResult = {
  /**
   * Current-window usage per enabled rule.
   */
  rules: Array<SpendRuleUsage>;
  /**
   * Total enabled rules.
   */
  rulesTotal: number;
  /**
   * Enabled rules whose status is not healthy.
   */
  rulesUnhealthy: number;
  /**
   * Current spend over planned budget in USD, summed across actors over their per-person limits.
   */
  spendOverBudgetUsd: number;
  /**
   * Total budgeted spend in USD across enabled rules (per-person limits times matched users).
   */
  totalBudgetUsd: number;
  /**
   * Spend in USD across all users matched by enabled rules, in each rule's current window.
   */
  totalSpendUsd: number;
  /**
   * Distinct users at or past the limit of at least one enabled rule.
   */
  usersBreached: number;
  /**
   * Distinct users matched by at least one enabled rule.
   */
  usersTotal: number;
};

/** @internal */
export const SpendRulesOverviewResult$inboundSchema: z.ZodMiniType<
  SpendRulesOverviewResult,
  unknown
> = z.pipe(
  z.object({
    rules: z.array(SpendRuleUsage$inboundSchema),
    rules_total: z.int(),
    rules_unhealthy: z.int(),
    spend_over_budget_usd: z.number(),
    total_budget_usd: z.number(),
    total_spend_usd: z.number(),
    users_breached: z.int(),
    users_total: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "rules_total": "rulesTotal",
      "rules_unhealthy": "rulesUnhealthy",
      "spend_over_budget_usd": "spendOverBudgetUsd",
      "total_budget_usd": "totalBudgetUsd",
      "total_spend_usd": "totalSpendUsd",
      "users_breached": "usersBreached",
      "users_total": "usersTotal",
    });
  }),
);

export function spendRulesOverviewResultFromJSON(
  jsonString: string,
): SafeParseResult<SpendRulesOverviewResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SpendRulesOverviewResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SpendRulesOverviewResult' from JSON`,
  );
}
